import $ from 'jquery';

const Accordion = {
    callbacks: {
        show: {},
        hide: {},
        toggle: {},
    },

    open(domItem) {
        if (this.callbacks.show[domItem]) {
            this.callbacks.show[domItem]();
        }
        $(domItem).addClass('accordion--opened');
    },

    close(domItem = '') {
        if (this.callbacks.hide[domItem]) {
            this.callbacks.hide[domItem]();
        }
        $(domItem).removeClass('accordion--opened');
    },

    toggle(domItem = '') {
        if (this.callbacks.toggle[domItem]) {
            this.callbacks.toggle[domItem]();
        }

        $(domItem).toggleClass('accordion--opened');
    },

    closeAll() {
        $('.accordion').removeClass('accordion--opened');
    },

    toggleAll() {

    }
};

export default Accordion;
